import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import VinwonderTagGroup from 'models/VinWonderTagGroup';

export function getVinwonderTagGroups(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_LIST,
        params: params
    }).get();
}
export function dragToOrderTag(payload) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_REORDER,
    }).put(payload);
}

export function updateDefaultTag(payload) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_SET_DEFAULT,
    }).put(payload);
}
export function getSupplierCategories(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_SUPPLIER_LIST,
        params
    }).get();
}

export function getSkuFollowSupplier(params) {
    return new ApiService({
        baseURL: Config.API_TOUR_V2,
        endpoint: Urls.VIN_WONDER_TAGGROUP_FOLLOW_SUPPLIER,
        params: params
    }).get();
}
export function createVinwonderTagGroup(vinWonderTagGroup) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP,
    }).post(vinWonderTagGroup);
}

export function getDetailVinwonderTagGroup(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: `${Urls.VIN_WONDER_TAGGROUP}/${id}`,
        parser: data => new VinwonderTagGroup(data.data),
    }).get();
}

export function updateVinwonderTagGroup(vinWonderTagGroup) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP,
    }).put(vinWonderTagGroup);
}

export function deleteVinWonderTagGroup(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: `${Urls.VIN_WONDER_TAGGROUP}/${id}`,
    }).delete();
}

export function createVinwonderTagGroupTranslate(vinWonderTagGroup) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_TRANSLATE_CREATE,
    }).post(vinWonderTagGroup.export(true).translate());
}

export function updateVinwonderTagGroupTranslate(vinWonderTagGroup) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_TRANSLATE_UPDATE,
    }).put(vinWonderTagGroup.export(true).translate());
}

export function deleteVinwonderTagGroupTranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.VIN_WONDER_TAGGROUP_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}
